import { jsxs as m, jsx as o } from "react/jsx-runtime";
import n from "classnames";
import s from "../../Icons/Close.js";
import { Logo as f } from "../../Logo/Logo.js";
import e from "../../../utils/colors.js";
import { useSidenavContext as p } from "../context.js";
import { HeadWrapper as a, StyledLogo as c, StyledClose as d } from "./styles.js";
const j = ({ href: l = "#", className: r = "", onLogoClick: t = () => {
} }) => {
  const { setIsOpen: i } = p();
  return /* @__PURE__ */ m(a, { className: n({ [r]: !!r }), children: [
    /* @__PURE__ */ o(c, { children: /* @__PURE__ */ o(f, { href: l, onClick: t, fill: e.logoOrange }) }),
    /* @__PURE__ */ o(d, { onClick: () => i(!1), children: /* @__PURE__ */ o(s, { fill: e.logoOrange }) })
  ] });
};
export {
  j as default
};
